import Vue from 'vue'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

Vue.component('vue-json-pretty', VueJsonPretty)
